import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '../assets/positive-icon.svg'
import _imports_1 from '../assets/negative-icon.svg'


const _hoisted_1 = { class: "strengths-and-gaps-list" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "positive"
  }),
  /*#__PURE__*/_createElementVNode("h3", null, "Strengths")
], -1)
const _hoisted_3 = { class: "strengths-list" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "negative"
  }),
  /*#__PURE__*/_createElementVNode("h3", null, "Gaps")
], -1)
const _hoisted_5 = { class: "gaps-list" }

import { computed } from "vue";
import { StrengthItemRatingApiModel } from "../api-models";


export default /*#__PURE__*/_defineComponent({
  __name: 'strengths-and-gaps-list',
  props: {
    ratings: {}
  },
  setup(__props: any) {

const props = __props;

const topStrengthRatings = computed(() => {
  if (!props.ratings) return [];

  return props.ratings.slice(0, 5);
});

const gapRatings = computed(() => {
  if (!props.ratings) return [];

  return props.ratings.slice(-5);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", null, [
      _createElementVNode("ul", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(topStrengthRatings.value, (rating) => {
          return (_openBlock(), _createElementBlock("li", {
            key: rating.strength.name,
            "data-test": "strengths-list-item"
          }, _toDisplayString(rating.strength.name), 1))
        }), 128))
      ])
    ]),
    _hoisted_4,
    _createElementVNode("div", null, [
      _createElementVNode("ul", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(gapRatings.value, (rating) => {
          return (_openBlock(), _createElementBlock("li", {
            key: rating.strength.name,
            "data-test": "gaps-list-item"
          }, _toDisplayString(rating.strength.name), 1))
        }), 128))
      ])
    ])
  ]))
}
}

})